import { motion } from "framer-motion";

export function PageHeader({ title, subtitle, children, testId }) {
  return (
    <div className="mb-7 flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between" data-testid={testId}>
      <div>
        <motion.h1 initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.4 }}
          className="font-sans text-2xl font-semibold tracking-tight text-white sm:text-3xl">
          {title}
        </motion.h1>
        {subtitle && <p className="mt-1 font-sans text-sm text-zinc-500">{subtitle}</p>}
        <div className="mt-3 h-px w-16 dlx-hairline" />
      </div>
      {children && <div className="flex flex-wrap items-center gap-2">{children}</div>}
    </div>
  );
}

export function Loading({ label = "Caricamento…" }) {
  return (
    <div className="flex min-h-[50vh] flex-col items-center justify-center gap-4">
      <div className="h-8 w-8 rounded-full border-2 border-gold/20 border-t-gold dlx-spin" />
      <span className="font-mono text-xs tracking-widest text-zinc-500">{label}</span>
    </div>
  );
}

export function Empty({ label = "Nessun dato disponibile" }) {
  return (
    <div className="dlx-card flex min-h-[200px] items-center justify-center p-8">
      <span className="font-sans text-sm text-zinc-500">{label}</span>
    </div>
  );
}

export function StatRow({ label, value, tone }) {
  const color = tone === "profit" ? "text-profit" : tone === "loss" ? "text-loss" : "text-white";
  return (
    <div className="flex items-center justify-between border-b border-white/5 py-2.5 last:border-0">
      <span className="font-sans text-[13px] text-zinc-400">{label}</span>
      <span className={`font-mono text-sm font-medium ${color}`}>{value}</span>
    </div>
  );
}
